<template>
  <div class="qualifying-controls clearfix">
    <button
      :class="[
        'control',
        'control-one-third',
        'decide-button',
        'fail-button',
        { fail: decision === 'fail' }
      ]"
      @click.prevent="decision = 'fail'"
    >
      <span>{{ lang.get('qualifying.controls.fail') }}</span>
      <i class="af-icons af-icons-cross"></i>
    </button>
    <button
      :class="[
        'control',
        'control-one-third',
        'decide-button',
        'pass-button',
        { pass: decision === 'pass' }
      ]"
      @click.prevent="decision = 'pass'"
    >
      <span>{{ lang.get('qualifying.controls.pass') }}</span>
      <i class="af-icons af-icons-tick"></i>
    </button>
  </div>
</template>

<script>
export default {
  inject: ['lang'],
  data() {
    return {
      decision: null
    };
  }
};
</script>
